var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLearning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10616",
    "data-name": "Group 10616",
    transform: "translate(-350 -244)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 30,
    height: 30,
    transform: "translate(350 244)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "book-alt",
    d: "M22.024,2.278A5.5,5.5,0,0,0,17.477,1.1l-3.283.688A4.487,4.487,0,0,0,12,2.854,4.4,4.4,0,0,0,9.845,1.792l-3.361-.7A5.5,5.5,0,0,0,0,6.5v9.792A5.492,5.492,0,0,0,4.493,21.7L10.3,22.847A9.431,9.431,0,0,0,11.994,23a9.658,9.658,0,0,0,1.728-.157L19.484,21.7A5.5,5.5,0,0,0,24,16.293V6.5a5.487,5.487,0,0,0-1.976-4.222ZM10.5,19.829,5.053,18.753A2.5,2.5,0,0,1,3,16.293V6.5A2.507,2.507,0,0,1,5.494,4a2.285,2.285,0,0,1,.414.037l3.361.7A1.5,1.5,0,0,1,10.5,6.212ZM21,16.293a2.506,2.506,0,0,1-2.075,2.464L13.5,19.829V6.212a1.511,1.511,0,0,1,1.271-1.483l3.282-.687A2.5,2.5,0,0,1,21,6.5Z",
    transform: "translate(353 246.998)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLearning);
export default __webpack_public_path__ + "static/media/ic_learning.259328a50ad239736bb04f614972260f.svg";
export { ForwardRef as ReactComponent };